import React from 'react';

import { Link } from 'react-router-dom';

import classNames from 'classnames/bind';
import styles from './Links.scss';
const cx = classNames.bind(styles);

const Links = React.memo(({ links = [], style = {} }) => {
  return (
    <div className={cx('Links')} style={style}>
      {links.map(item => {
        if (item.to) {
          return (
            <Link key={`links-key-${item.id}`} to={item.to}>
              {item.title}
            </Link>
          );
        }
        return (
          <button
            key={`links-key-${item.id}`}
            type={item.type}
            onClick={item.onClick}
          >
            {item.title}
          </button>
        );
      })}
    </div>
  );
});

export default Links;
